












































import { Component, Vue, Prop } from 'vue-property-decorator'
import CardMenu from './Components/CardMenu.vue'
import BarChart from './Components/BarChart/BarChart.vue'
import FilterMenu from './Components/FilterTable.vue'
import FilterDealer from './Components/FilterTablePowerUser.vue'
import TableMenu from './Components/TableMenu.vue'
import TopMenu from './Components/TopMenu.vue'
import LineChart, { ILineChartData } from './Components/LineChart/LineChart.vue'
import { BulletinReportModule } from '@/app/store/modules/bulletinReport'
import { AuthModule } from '@/app/store/modules/auth'
import { UserReportModule } from '@/app/store/modules/userReport'
import { ExportData } from '@/domain/entities/BulletinReport'

@Component({
  name: 'UserReports',
  components: {
    'top-menu': TopMenu,
    'bar-chart': BarChart,
    'filter-menu': FilterMenu,
    'filter-dealer': FilterDealer,
    'card-menu': CardMenu,
    'line-chart': LineChart,
    'table-menu': TableMenu,
  },
})
export default class extends Vue {
  public created() {
    BulletinReportModule.paginationParam.filter.salescode = ''
    BulletinReportModule.paginationParam.filter.position = ''
    BulletinReportModule.paginationParam.filter.filecode = ''
    BulletinReportModule.paginationParam.filter.dealer = ''
    BulletinReportModule.paginationParam.filter.city = ''
    BulletinReportModule.paginationParam.filter.branch = ''
    BulletinReportModule.paginationParam.filter.start = ''
    BulletinReportModule.paginationParam.filter.end = ''
    BulletinReportModule.paginationParamsExport.filter.start = ''
    BulletinReportModule.paginationParamsExport.filter.end = ''
    this.getBulletinData()
    this.getExportData()
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }

  public get getBulletinData(): any {
    return BulletinReportModule.getBulletinData
  }

  public get DataCharts(): any {
    return BulletinReportModule.bulletinData.chart
  }

  public get TopVisit(): any {
    return BulletinReportModule.bulletinData.topVisit
  }

  public get TopMenuData(): any {
    return BulletinReportModule.bulletinData.topMenu
  }
  public get isLoadingExport() {
    return BulletinReportModule.isLoadingExport
  }

  public get getExportData(): any {
    return BulletinReportModule.getExportData
  }
  public get linkExport(): ExportData | undefined {
    return BulletinReportModule.exportData.data
  }

  public get isLoading(): boolean {
    return BulletinReportModule.isLoading
  }
  // Property Top Menu
  private funcFilter(data) {
    BulletinReportModule.paginationParam.filter.salescode = data.salescode
    BulletinReportModule.paginationParam.filter.position = data.position
    BulletinReportModule.paginationParam.filter.filecode = data.filecode
    BulletinReportModule.paginationParam.filter.dealer = data.dealerNameId
    BulletinReportModule.paginationParam.filter.city = data.cityId
    BulletinReportModule.paginationParam.filter.branch = data.dealerBranchId
    BulletinReportModule.paginationParam.filter.start = data.filterDate[0]
    BulletinReportModule.paginationParam.filter.end = data.filterDate[1]
    BulletinReportModule.paginationParamsExport.filter.start =
      data.filterDate[0]
    BulletinReportModule.paginationParamsExport.filter.end = data.filterDate[1]
    this.getBulletinData()
    this.getExportData()
  }

  private funcClearFilter() {
    this.clearFilter()
    BulletinReportModule.paginationParam.filter.salescode = ''
    BulletinReportModule.paginationParam.filter.position = ''
    BulletinReportModule.paginationParam.filter.filecode = ''
    BulletinReportModule.paginationParam.filter.dealer = ''
    BulletinReportModule.paginationParam.filter.city = ''
    BulletinReportModule.paginationParam.filter.branch = ''
    BulletinReportModule.paginationParam.filter.start = ''
    BulletinReportModule.paginationParam.filter.end = ''
    BulletinReportModule.paginationParamsExport.filter.start = ''
    BulletinReportModule.paginationParamsExport.filter.end = ''
    this.getBulletinData()
    this.getExportData()
  }

  public get dataAccessRateCharts(): any {
    return BulletinReportModule.bulletinData.accessRateCharts
  }

  public get hasFilter(): boolean {
    if (
      BulletinReportModule.paginationParam.filter.salescode !== '' ||
      BulletinReportModule.paginationParam.filter.position !== '' ||
      BulletinReportModule.paginationParam.filter.filecode !== '' ||
      BulletinReportModule.paginationParam.filter.dealer !== '' ||
      BulletinReportModule.paginationParam.filter.city !== '' ||
      BulletinReportModule.paginationParam.filter.branch !== '' ||
      BulletinReportModule.paginationParam.filter.start !== '' ||
      BulletinReportModule.paginationParam.filter.end !== ''
    ) {
      return true
    } else {
      return false
    }
  }
  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }
  private onClearInputSearch: boolean = false

  private clearInputSearch() {
    if (this.onClearInputSearch === false) {
      this.onClearInputSearch = true
    } else {
      this.onClearInputSearch = false
    }
  }

  private nameCharts = 'Trend Total User Visit'
}
